<div
  class="min-h-screen grid grid-cols-1 md:grid-cols-2 p-0 bg-cover bg-no-repeat bg-center bg-none md:bg-[url('/Background.svg')]">
  <!-- Left panel (Card) -->

  <div class="bg-white rounded-0 md:rounded-3xl shadow-lg p-10 lg:p-10 md:p-5 lg:m-12 md:m-5 sm:m-0 xl:m-15 2xl:m-30">
    <!-- Logo -->
    <div
      class="flex items-start justify-center md:justify-start gap-3 lg:min-h-[133px] sm:min-h-[50px] md:min-h-[85px]">
      <img src="/logo.svg" alt="plandag logo" class="h-10" />
      <span
        class="text-4xl font-semibold tracking-tight text-[#00165A] flex justify-center md:justify-start">plandag</span>
    </div>

    <div class="content-container sm:pr-2">
      <!-- Email Step -->
      <ng-container *ngIf="!showOrgSelection">
        <div class="space-y-2 mb-6">
          <h1
            class="md:text-3xl text-2xl md:my-1 my-4 font-medium md:font-bold text-[#00165A] flex justify-center md:justify-start">
            {{ i18n.t('welcome') }}
          </h1>
          <p class="text-sm text-slate-600 flex justify-center md:justify-start">
            {{ i18n.t('welcomeMessage') }}
          </p>
        </div>

        <form class="form-container" [formGroup]="loginForm">
          <div class="mb-4">
            <app-input #emailRef formControlName="email" [submitted]="submitted" [label]="i18n.t('email')"
              labelCustomClass="block mb-1 font-medium text-gray-700"
              inputCustomClass="border border-gray-300 rounded-md px-3 h-[42px] w-full">
            </app-input>
          </div>

          <div class="w-full">
            <app-button [label]="i18n.t('continue')" type="submit" severity="info" customClass="wideButton w-full custom-dark-blue"
              size="large" [loading]="loading" (click)="onLogin()"></app-button>
          </div>
        </form>
      </ng-container>

      <!-- Organization Selection Step -->
      <ng-container *ngIf="showOrgSelection">
        <div class="space-y-2 mb-6">
          <h1
            class="md:text-3xl text-2xl md:my-1 my-4 font-medium md:font-bold text-[#00165A] flex justify-center md:justify-start">
            {{ i18n.t('selectOrganization') }}
          </h1>
          <p class="text-sm text-slate-600 leading-relaxed">
            {{ i18n.t('theEmail') }} <span class="font-semibold text-[#00165A] bg-slate-100 px-1.5 py-0.5 rounded">{{email}}</span>
            {{ i18n.t('isAssociatedWithMultipleOrganizations') }}
          </p>
          <p class="text-sm text-slate-600">
            {{ i18n.t('organizationEmailMessage') }}
          </p>
        </div>

        <div class="form-container space-y-4">
          <div class="mb-4">
            <app-dropdown [(ngModel)]="selectedOrgId" [options]="organizations" optionLabel="name" optionValue="id"
              [label]="i18n.t('organization')" [placeholder]="i18n.t('chooseOrganization')" [filter]="true"
              labelCustomClass="block mb-1 font-medium text-gray-700" inputCustomClass="text-sm md:text-base w-full"
              [submitted]="submitted"></app-dropdown>
          </div>

          <div class="w-full flex flex-col gap-3">
            <app-button [label]="i18n.t('continue')" severity="info"
              customClass="wideButton w-full custom-dark-blue shadow-md hover:shadow-lg transition-all duration-300"
              size="large" [disabled]="!selectedOrgId" (click)="onSelectOrg()"></app-button>
            <button (click)="backToEmail()"
              class="w-full py-2.5 text-sm font-medium text-gray-600 hover:text-[#00165A] transition-colors duration-200 flex items-center justify-center gap-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18">
                </path>
              </svg>
              {{ i18n.t('backToLogin') }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Right panel (Background + Marketing) -->
  <div class="hidden md:flex items-center justify-center">
    <div class="relative z-10 max-w-lg text-center space-y-8">
      <h2 class="text-4xl font-extrabold leading-tight text-[#00165A]">
        {{ i18n.t('theSimplestWayToManage') }}<br />{{ i18n.t('yourWorkforce') }}
      </h2>

      <div class="mt-4 flex items-center flex-col justify-center">
        <p-carousel [value]="products" [numVisible]="1" [numScroll]="1" [circular]="true" [autoplayInterval]="3000"
          class="mt-4 mx-auto max-w-4xl w-full" contentClass="flex justify-center">
          <ng-template pTemplate="item" let-product>
            <div class="m-2 p-4 w-full flex justify-center">
              <div class="bg-white rounded-2xl shadow-md p-6 w-full max-w-[360px]">
                <div class="text-[#00165A] font-semibold mb-3">
                  {{ product.name }}
                </div>
                <img [src]="product.image" [alt]="product.name"
                  class="w-full h-[165px] object-contain rounded-md mx-auto" />
              </div>
            </div>
          </ng-template>
        </p-carousel>

        <p class="mt-4 text-xs text-slate-600 text-center">
          {{ i18n.t('loginRightPanelMessage') }}
        </p>
      </div>
    </div>
  </div>
</div>